import { effect, Inject, Injectable, signal, WritableSignal } from '@angular/core';

import { Theme } from 'src/app/model';
import { DOCUMENT } from '@angular/common';

export const THEME_STORAGE_KEY = "theme";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  // Miscellaneous
  private _themeSignal: WritableSignal<string> = signal<string>(Theme.GLOBAL);
  private _prevTheme: string = Theme.GLOBAL;
  
  constructor(
    @Inject(DOCUMENT) private _document: Document
  ) {
    // Initialize theme
    this._initializeTheme();
    // Call _updateRenderedTheme on value change of _themeSignal
    effect(() => {
      this._updateRenderedTheme();
    });
  }

  /**
   * Switchs to tenant theme
   * @param tenant
   */
  switchTheme(): void {
    if(localStorage.getItem('tenantGenericTheme') != 'undefined'){
      this._setThemeSignal(localStorage.getItem('tenantGenericTheme')?.toLowerCase());
    } else {
      const tenant = localStorage.getItem('domain')?.toLowerCase() ?? Theme.GLOBAL;
      this._setThemeSignal(tenant);
    }
  }

  /**
   * Initializes theme
   */
  private _initializeTheme(): void {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    if (storedTheme) {
      this._setThemeSignal(storedTheme);
    }
  }

  /**
   * Updates rendered theme
   */
  private _updateRenderedTheme(): void {
    this._setClass();
    // Set theme in local storage
    this._setThemeInLocalStorage();
  }

  /**
   * Sets theme in local storage
   */
  private _setThemeInLocalStorage() {
    // Set THEME_STORAGE_KEY in localStorage
    localStorage.setItem(THEME_STORAGE_KEY, this._themeSignal());
  }

  /**
   * Sets class
   */
  private _setClass() {
    // Create class name
    const newClass = 'theme-' + this._themeSignal();
    const prevClass = 'theme-' + this._prevTheme;
    // Set class
    if (newClass !== prevClass) {
      this._document?.body?.classList?.replace(prevClass, newClass);
    } else {
      this._document?.body?.classList?.add(newClass);
    }
  }

  /**
   * Sets theme signal
   * @param theme
   */
  private _setThemeSignal(theme: string) {
    this._themeSignal.update((prevTheme) => {
      this._prevTheme = prevTheme;
      return theme?.toLowerCase();
    });
  }
}
